import React from "react";

const Header = () => {
  return (
    <header className="pt-8 md:pt-12 pb-6 md:pb-8 px-4 md:px-8" style={{ maxWidth: '1400px', margin: '0 auto' }}>
      <h3 
        className="text-black font-normal"
        style={{
          fontSize: 'clamp(20px, 4vw, 25.6px)',
          lineHeight: 'clamp(28px, 5vw, 34.98px)',
          fontFamily: '"Helvetica Neue", Arial, sans-serif',
          fontWeight: 400,
          marginBottom: 'clamp(20px, 4vw, 32px)'
        }}
      >
        emdash –
      </h3>
    </header>
  );
};

export default Header;